<template>
  <div id="app">
  <!-- Loader starts-->
    <div class="loader-wrapper" :class="{'loderhide' : !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div>

    <div class="loader-wrapper" style="background-color: rgba(0,0,0,0.5)" v-show="isLoading">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'Gob_app',
    data(){
      return{
        show: true
      };
    },
    mounted() {
      this.timeOut();
    },
    created() {
      // this.$store.dispatch('shared/tryAutoLogin');
    },
    methods:{
      timeOut(){
        var self = this;
        setTimeout(function(){
          self.show = false;
        }, 500);
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters['shared/isLoading']
      }
    }
  };
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
